<div class="position-relative text-center w-100" [appStoryblok]="_editable">
  @defer (on idle){
  <img
    height="500"
    width="400"
    class="d-lg-none mobile w-100 h-auto"
    [ngSrc]="image_mobile.filename"
    *ngIf="image_mobile.filename"
  />
  <img
    height="800"
    width="800"
    [ngClass]="{ 'd-none': image_mobile.filename }"
    class="d-lg-block desktop w-100 h-auto"
    [ngSrc]="image.filename"
    *ngIf="image.filename"
  />
  } @placeholder {
  <div class="bg-secondary"></div>
  }
</div>
